import { t } from "i18next";

import { LocalizationObjectType } from "@models/utils/localisation.models";
import { applyLocalization } from "@services/common.service";

/* eslint-disable no-unused-vars */
export enum CONTACT_PERSON_TYPES {
  LOCATION = "location",
  RESOURCE = "resource",
}

export enum MANAGING_TYPES {
  INFO = "info",
  UNIT = "units",
}

export enum PROFILE_DATA {
  COMPANY_NAME = "companyName",
}

export const designationMap = (
  terminology: LocalizationObjectType,
  unitType: LocalizationObjectType
): { [key: string]: string } => {
  return {
    location: t("locationManager", {
      location: applyLocalization(terminology, "Location"),
    }),
    ["location,unit"]: t("locationUnitManager", {
      location: applyLocalization(terminology, "Location"),
      unit: applyLocalization(unitType),
    }),
    unit: t("unitManager", {
      unit: applyLocalization(unitType),
    }),
  };
};

export const languageTrans: { [key: string]: string } = {
  DE: "german",
  EN: "english",
  FR: "french",
  IT: "italian",
};
